import React, { useRef } from "react";
import { Button, type ButtonProps as MantineButtonProps } from "@mantine/core";

type UploadButtonProps = {
  onFileSelected: (event: React.ChangeEvent<HTMLInputElement>) => void;
  buttonText: string;
} & MantineButtonProps;

const UploadButton: React.FC<UploadButtonProps> = ({ onFileSelected, buttonText, ...props }) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleButtonClick = () => fileInputRef.current?.click();

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files && files.length > 0) onFileSelected(event);
  };

  return (
    <>
      <Button
        color="green"
        onClick={handleButtonClick}
        leftSection={<i className="fa fa-upload fa-fw" aria-hidden="true" />}
        {...props}
      >
        {buttonText}
      </Button>

      <input type="file" ref={fileInputRef} style={{ display: "none" }} onChange={handleFileChange} />
    </>
  );
};

export default UploadButton;
